import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartProvider from "./context/CartContext";
import AuthProvider from "./context/AuthContext";
import { RequireAuth, RequireAdmin } from "./components/RouteGuards";
import FloatingWhatsApp from "./components/FloatingWhatsapp";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminOrders from "./pages/admin/AdminOrders";
import AvisoLegal from "./pages/Aviso";
import ClausulaCookies from "./pages/Cookies";
import PoliticaPrivacidad from "./Privacidad";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Routes>
          {/* Admin — its own layout, no storefront header/footer */}
          <Route element={<RequireAdmin />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminProducts />} />
              <Route path="productos" element={<AdminProducts />} />
              <Route path="productos/nuevo" element={<AdminProductForm />} />
              <Route path="productos/:id" element={<AdminProductForm />} />
              <Route path="pedidos" element={<AdminOrders />} />
            </Route>
          </Route>

          {/* Storefront */}
          <Route
            path="*"
            element={
              <div className="app">
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/moviles" element={<Products />} />
                    <Route path="/movil/:sku" element={<ProductDetail />} />
                    <Route path="/carrito" element={<Cart />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/registro" element={<Register />} />
                    <Route path="/aviso-legal" element={<AvisoLegal />} />
                    <Route path="/proteccion-datos" element={<ClausulaCookies />} />
                    <Route path="/privacidad" element={<PoliticaPrivacidad />} />



                    <Route element={<RequireAuth />}>
                      <Route path="/pago" element={<Checkout />} />
                      <Route path="/cuenta" element={<Account />} />
                    </Route>

                    <Route path="*" element={<Home />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            }
          />
        </Routes>
         <FloatingWhatsApp />
      </CartProvider>
    </AuthProvider>
  );
}